import { default as MuiSkeleton } from '@mui/material/Skeleton';

/**
 * Skeletons display a placeholder preview of content before data gets loaded.
 *
 * Demos:
 *
 * - [Skeleton](https://unify.workiva.org/components/skeleton?tab=code)
 *
 * API:
 *
 * - [Skeleton API](https://unify.workiva.org/components/skeleton?tab=props)
 */
export const Skeleton = MuiSkeleton;
export { type SkeletonProps, skeletonClasses } from '@mui/material/Skeleton';
